module.exports = __webpack_public_path__ + "static/pylehti-page-001.48634301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pylehti-page-001.jpg
// module id = 842
// module chunks = 270650965324815